import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { Constants } from '../helpers';
import { Paginate, PostParams, AccountingAuditResponse, AccountingAuditsResponse } from '../interfaces';

@Injectable()
export class AccountingAuditService {

	constructor(
		private http: HttpClient,
	) {
	}

	/**
	 * Gets Accounting Audits for pagination
	 * @returns {Observable<any>}
	 */
	public postPaginate(pagin: Paginate) {
		return this.http.post<AccountingAuditsResponse>(`${Constants.BASE_API_URL}/external-accounting/paginate`, pagin).pipe(map(res => res.audits));
	}
	
	/**
	 * Gets totalCount
	 * @returns {Observable<any>}
	 */
	public postCount(params?: PostParams) {
		return this.http.post<any>(`${Constants.BASE_API_URL}/external-accounting/count`, { params }).pipe(map(res => res.total));
	}
	
	/**
	 * Gets deep audit for auditId
	 * @returns {Observable<any>}
	 */
	public getAudit(auditId: string) {
		return this.http.get<AccountingAuditResponse>(`${Constants.BASE_API_URL}/external-accounting/audit`, {
				params: { auditId: auditId },
			})
			.pipe(
				map(res => {
					return res.audit;
				}),
			);
	}

	/**
	 * Checks if there are any audit log warnings present
	 * @returns {Observable<boolean>}
	 */
	public hasLogWarning() {
		return this.http.get<{ status: boolean; logWarning: boolean }>(`${Constants.BASE_API_URL}/external-accounting/audit-log-warning`)
			.pipe(map(res => res.logWarning));
	}

	/**
	 * Dismisses the audit log warning banner by calling paginate (triggers dismissLogWarnings in backend)
	 * @returns {Observable<boolean>}
	 */
	public dismissLogWarnings() {
		return this.http.post<AccountingAuditsResponse>(`${Constants.BASE_API_URL}/external-accounting/paginate`, { 
			skip: 0, 
			limit: 0, 
			params: {} 
		}).pipe(map(res => res.status));
	}
}
